import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import IconEvents from '../../static/images/icons/calendar.png';
import IconTickets from '../../static/images/icons/ticket.png';
import IconProfile from '../../static/images/icons/account.png';

class LeftMenu extends Component {
    render() {
        return (
            <div>
                <ul className="leftMenu">
                    <li className="menu-item">
                        <Link to="/"><img src={IconEvents} className="menuIcon"/> Próximos Eventos</Link>
                    </li>
                    <li className="menu-item">
                        <Link to="/tickets"><img src={IconTickets} className="menuIcon" /> Mis Boletas</Link>
                    </li>
                    <li className="menu-item">
                        <Link to="/profile"><img src={IconProfile} className="menuIcon" /> Editar mi Perfil</Link>
                    </li>
                </ul>
            </div>
        );
    }
}

export default LeftMenu;



// WEBPACK FOOTER //
// ./src/Components/Menu/leftmenu.js